import React, { useState, createContext, useContext } from "react";

export const ViewWalletContext = createContext();

export default function ViewWalletPopoverProvider({ children }) {
  const [viewWalletPopoverStatus, setViewWalletPopoverStatus] = useState(null);

  return (
    <ViewWalletContext.Provider value={{ viewWalletPopoverStatus, setViewWalletPopoverStatus }}>
      {children}
    </ViewWalletContext.Provider>
  );
}

export const useViewWalletPopover = () => useContext(ViewWalletContext);
